import { apiCall } from '../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../Utils/Auth/AuthToken';

const { accessToken } = getTokensFromStorage();

/**
 * get Configuration Setting.
 * @returns {Promise} - A promise that resolves with the get Configuration Setting api or rejects with an error.
 */
export const getConfigurationSetting = async () => {
  let response = await apiRequest({
    url: `/configurations/rolloutconfig`,
    method: 'GET',
    accessToken,
  });
  return response;
};

/**
 * Save Configuration Setting.
 * @param {object} data - An object of Configuration data to update
 * @returns {Promise} - A promise that resolves with the save Configuration Setting api or rejects with an error.
 */
export const saveConfigurationSetting = async (data) => {
  let response = await apiRequest({
    url: `/configurations`,
    method: 'POST',
    body: JSON.stringify(data),
    accessToken,
  });
  return response;
};

/**
 * Verify DB Configuration.
 * @param {object} data - An object of Configuration data to verify
 * @returns {Promise} - A promise that resolves with the Verify DB Configuration api or rejects with an error.
 */
export const verifyDBConfig = async (data) => {
  let response = await apiRequest({
    url: `/DB/Verify`,
    method: 'POST',
    body: JSON.stringify(data),
    accessToken,
  });
  return response;
};

/**
 * Test version control connection.
 * @param {object} data - An object of version control configuration data to verify
 * @returns {Promise} - A promise that resolves with the test connection api or rejects with an error.
 */
export const testVersionControlConnection = async (data) => {
  let response = await apiRequest({
    url: `/configurations/version-control/test-connection`,
    method: 'POST',
    body: JSON.stringify(data),
    accessToken,
  });
  return response;
};

/**
 * Test issue management connection.
 * @param {object} data - An object of issue management configuration data to verify
 * @returns {Promise} - A promise that resolves with the test connection api or rejects with an error.
 */
export const testIssueManagementConnection = async (data) => {
  let response = await apiRequest({
    url: `/configurations/issue-assignment/test-connection`,
    method: 'POST',
    body: JSON.stringify(data),
    accessToken,
  });
  return response;
};

/**
 * Api Call Wrapper Method.
 * @param {object} api - Contains details like url headers method and data.
 * @returns {Promise} - A promise that resolves with the data or rejects with an error.
 */
const apiRequest = async (request) => {
  let response;
  try {
    response = await apiCall(request);
  } catch (e) {
    response = { isSuccess: false, message: e.message };
  }
  return response;
};
